var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"6","md":"6","sm":"12"}},[_c('maintainer-crop',{on:{"rowSelected":function($event){return _vm.rowSelected($event)}}})],1),_c('v-col',{attrs:{"cols":"12","lg":"6","md":"6","sm":"12"}},[_c('fruit-state',{attrs:{"TypeCultive":_vm.TypeCultive}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }